import { inject, Injectable } from '@angular/core';

import { LocalStorageService } from '@core/common-legacy';

@Injectable({ providedIn: 'root' })
export class UserInvitationCacheService {
  private readonly indexedDbService = inject(LocalStorageService);

  private readonly journeysDbKey = 'journeysPromoDialogDontShowAgain';

  public setJourneysPromoDialogFlag() {
    return this.indexedDbService.set(this.journeysDbKey, true);
  }

  public getJourneysPromoDialogFlag() {
    return this.indexedDbService.get(this.journeysDbKey);
  }
}
